import { z } from 'zod';
import { NotNullStringSchema } from '@/std/schema';

export const PessoaFotoSchema = z.object({
    pfo_empresa_idpk: z.number(),
    pfo_foto_path: NotNullStringSchema,
    pfo_idpk: z.number(),
    pfo_pessoa_idpk: z.number(),
    pfo_ultima_alteracao: z.string().nullable(),
});
